export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      work: 'Projects',
      about: 'About',
      blog: 'Blog',
      more: 'More',
      quickDM: 'Quick DM',
    },
    // Hero Section
    hero: {
      title: 'Musician, Composer, Producer',
      subtitle: 'Sound Engineer',
      name: 'Mauricio Guerra Navarro',
      location: 'Monterrey, México',
      description: 'With over 11 years of professional experience as a guitarist and music educator,',
      and: 'and',
      specializing: 'I bring extensive on-stage and studio expertise with',
      chatbots: 'thousands of streams',
      customAgents: 'across major platforms, delivering compelling sonic experiences',
      copyEmail: 'Copy Email',
      copied: 'Copied!',
    },
    // About Section
    about: {
      title: 'About me',
      intro: "I'm a passionate musician and sound engineer from Monterrey, México, dedicated to crafting immersive sonic experiences that resonate with audiences. My journey spans over a decade of musical exploration, from intimate studio sessions to electrifying live performances.",
      bio: "My musical foundation began with classical guitar training, evolving into a diverse skill set encompassing composition, production, and sound engineering. I specialize in blending analog warmth with digital precision, creating soundscapes that bridge traditional musicianship and modern production techniques. From recording and mixing to mastering and live sound reinforcement, I bring a comprehensive approach to every project.",
      skillsTitle: 'Expertise & Instruments',
      servicesTitle: 'Services',
      services: {
        automation: {
          title: 'Music Production & Composition',
          description: 'Original compositions and full production services',
        },
        webDev: {
          title: 'Sound Engineering & Mixing',
          description: 'Professional recording, mixing, and mastering',
        },
        appDev: {
          title: 'Live Performance & Session Work',
          description: 'On-stage performances and studio sessions',
        },
        seo: {
          title: 'Music Education',
          description: 'Guitar lessons and music theory instruction',
        },
      },
    },
    // Projects Section
    work: {
      title: 'My Projects',
      viewProject: 'View Project',
    },
    // Quick DM
    quickDM: {
      title: 'Quick DM',
      name: 'Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      message: 'Message',
      messagePlaceholder: 'Your message...',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message delivered! ✓',
    },
    // Footer
    footer: {
      rights: 'Developer Portfolio. All rights reserved.',
    },
  },
  es: {
    // Navegación
    nav: {
      home: 'Inicio',
      work: 'Proyectos',
      about: 'Acerca de',
      blog: 'Blog',
      more: 'Más',
      quickDM: 'Mensaje Rápido',
    },
    // Sección Hero
    hero: {
      title: 'Músico, Compositor, Productor',
      subtitle: 'Ingeniero de Sonido',
      name: 'Mauricio Guerra Navarro',
      location: 'Monterrey, México',
      description: 'Con más de 11 años de experiencia profesional como guitarrista y educador musical,',
      and: 'y',
      specializing: 'aporto amplia experiencia en escenario y estudio con',
      chatbots: 'miles de reproducciones',
      customAgents: 'en las principales plataformas, entregando experiencias sonoras cautivadoras',
      copyEmail: 'Copiar Email',
      copied: '¡Copiado!',
    },
    // Sección Acerca de
    about: {
      title: 'Acerca de mí',
      intro: 'Soy un músico e ingeniero de sonido apasionado de Monterrey, México, dedicado a crear experiencias sonoras inmersivas que resuenan con las audiencias. Mi trayectoria abarca más de una década de exploración musical, desde sesiones íntimas de estudio hasta presentaciones en vivo electrizantes.',
      bio: 'Mi fundación musical comenzó con entrenamiento en guitarra clásica, evolucionando hacia un conjunto de habilidades diversas que abarcan composición, producción e ingeniería de sonido. Me especializo en fusionar la calidez analógica con la precisión digital, creando paisajes sonoros que conectan la musicalidad tradicional con técnicas de producción modernas. Desde grabación y mezcla hasta masterización y refuerzo de sonido en vivo, aporto un enfoque integral a cada proyecto.',
      skillsTitle: 'Experiencia e Instrumentos',
      servicesTitle: 'Servicios',
      services: {
        automation: {
          title: 'Producción Musical y Composición',
          description: 'Composiciones originales y servicios de producción completos',
        },
        webDev: {
          title: 'Ingeniería de Sonido y Mezcla',
          description: 'Grabación, mezcla y masterización profesional',
        },
        appDev: {
          title: 'Presentaciones en Vivo y Sesiones',
          description: 'Actuaciones en escenario y sesiones de estudio',
        },
        seo: {
          title: 'Educación Musical',
          description: 'Clases de guitarra e instrucción de teoría musical',
        },
      },
    },
    // Sección de Proyectos
    work: {
      title: 'Mis Proyectos',
      viewProject: 'Ver Proyecto',
    },
    // Mensaje Rápido
    quickDM: {
      title: 'Mensaje Rápido',
      name: 'Nombre',
      namePlaceholder: 'Tu nombre',
      email: 'Email',
      emailPlaceholder: 'tu@email.com',
      message: 'Mensaje',
      messagePlaceholder: 'Tu mensaje...',
      send: 'Enviar Mensaje',
      sending: 'Enviando...',
      success: '¡Mensaje enviado! ✓',
    },
    // Pie de página
    footer: {
      rights: 'Portafolio de Desarrollador. Todos los derechos reservados.',
    },
  },
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      work: 'Projets',
      about: 'À propos',
      blog: 'Blog',
      more: 'Plus',
      quickDM: 'Message Rapide',
    },
    // Section Hero
    hero: {
      title: 'Musicien, Compositeur, Producteur',
      subtitle: 'Ingénieur du Son',
      name: 'Mauricio Guerra Navarro',
      location: 'Monterrey, Mexique',
      description: 'Avec plus de 11 ans d\'expérience professionnelle en tant que guitariste et éducateur musical,',
      and: 'et',
      specializing: 'j\'apporte une vaste expertise scénique et studio avec',
      chatbots: 'des milliers d\'écoutes',
      customAgents: 'sur les principales plateformes, offrant des expériences sonores captivantes',
      copyEmail: 'Copier l\'Email',
      copied: 'Copié!',
    },
    // Section À propos
    about: {
      title: 'À propos de moi',
      intro: 'Je suis un musicien et ingénieur du son passionné de Monterrey, au Mexique, dédié à la création d\'expériences sonores immersives qui résonnent avec le public. Mon parcours s\'étend sur plus d\'une décennie d\'exploration musicale, des sessions de studio intimes aux performances live électrisantes.',
      bio: 'Ma fondation musicale a commencé avec une formation en guitare classique, évoluant vers un ensemble de compétences diverses englobant la composition, la production et l\'ingénierie du son. Je me spécialise dans le mélange de la chaleur analogique avec la précision numérique, créant des paysages sonores qui relient la musicalité traditionnelle aux techniques de production modernes. De l\'enregistrement et du mixage au mastering et au renforcement sonore en direct, j\'apporte une approche complète à chaque projet.',
      skillsTitle: 'Expertise et Instruments',
      servicesTitle: 'Services',
      services: {
        automation: {
          title: 'Production Musicale et Composition',
          description: 'Compositions originales et services de production complets',
        },
        webDev: {
          title: 'Ingénierie du Son et Mixage',
          description: 'Enregistrement, mixage et mastering professionnels',
        },
        appDev: {
          title: 'Performances Live et Sessions',
          description: 'Performances sur scène et sessions en studio',
        },
        seo: {
          title: 'Éducation Musicale',
          description: 'Cours de guitare et instruction de théorie musicale',
        },
      },
    },
    // Section Projets
    work: {
      title: 'Mes Projets',
      viewProject: 'Voir le Projet',
    },
    // Message Rapide
    quickDM: {
      title: 'Message Rapide',
      name: 'Nom',
      namePlaceholder: 'Votre nom',
      email: 'Email',
      emailPlaceholder: 'votre@email.com',
      message: 'Message',
      messagePlaceholder: 'Votre message...',
      send: 'Envoyer le Message',
      sending: 'Envoi...',
      success: 'Message envoyé! ✓',
    },
    // Pied de page
    footer: {
      rights: 'Portfolio de Développeur. Tous droits réservés.',
    },
  },
};
